/**
 * Common loader component
 *
 * Properties:
 *
 *      mediumWidth:    string, width in columns (1 - 12) for devices with big screens
 *      smallWidth:     string, width in columns (1 - 12) for devices with small screens
 *      subLoaders:     number, number of subsegments
 */

import React from "react";

const Loader = (props: any) => {
  let subLoaders = [];
  for (let i = 0; i < props.subLoaders; i++) {
    subLoaders.push(i);
  }

  return (
    <div>
      <div className="inb-c-loader">
        <div className="inb-c-loader--item inb-c-loader--sidebar-top">
          <div className="inb-c-loader--bg row"></div>
        </div>
      </div>
      {subLoaders.map((loader, index) => {
        return (
          <div key={index} className="inb-c-loader">
            <div className="inb-c-loader--item inb-c-loader--sidebar-center">
              <div className="inb-c-loader--bg row">
                <div
                  className={
                    "loader-mask r-1 medium-offset-8 medium-" +
                    props.mediumWidth +
                    " small-" +
                    props.smallWidth +
                    " column"
                  }
                ></div>
                <div className="loader-mask vert-ph-1"></div>
                <div className="loader-mask vert-ph-2"></div>
                <div
                  className={
                    "loader-mask r-2 medium-offset-9 medium-" +
                    (props.mediumWidth > 1 ? props.mediumWidth - 1 : "1") +
                    " small-" +
                    (props.smallWidth > 1 ? props.smallWidth - 1 : "1") +
                    " column"
                  }
                ></div>
                <div className="loader-mask vert-ph-3"></div>
                <div className="loader-mask vert-ph-4"></div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
export default Loader;
